import axios from 'axios';
import React from 'react';
import ReactJson from 'react-json-view';
import { CardElement, injectStripe } from 'react-stripe-elements';
import AEImg from '../../image/card-types/american_express.png';
import AndroidPayImg from '../../image/card-types/android_pay.png';
import ApplePayImg from '../../image/card-types/apple_pay.png';
import VISAImg from '../../image/card-types/visa.png';
import MasterImg from '../../image/card-types/master.png';
import DownloadGreenUpArrow from "../../image/download_green_arrow.png";
import PAYMENT_SERVER_URL from './../../constants/server';
import SplitFormWrapper from './formStyle';
import Checkbox from '../../components/uielements/checkbox';
import NProgress from 'nprogress';

// -- Components
import OverlayLoading from '../../components/OverlayLoading/index';

const handleBlur = () => {
  // console.log('[blur]');
};
const handleChange = change => {
  // console.log('[change]', change);
};
const handleClick = () => {
  // console.log('[click]');
};
const handleFocus = () => {
  // console.log('[focus]');
};
const handleReady = () => {
  // console.log('[ready]');
};

const createOptions = (fontSize) => {
  return {
    style: {
      base: {
        fontSize,
        color: '#424770',
        letterSpacing: '0.025em',
        fontFamily: 'Source Code Pro, Menlo, monospace',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#9e2146',
      },
    },
  };
};

class CheckoutForm extends React.Component {
    
    constructor(props) {
        super(props);
      
        this.state = {
          needLoading: false,
          // email: '',
          // name: '',
          // address: '',
          // city: '',
          // state: '',
          // country: 'HK',
          // postal_code: '',
          // referalToken: ''
        };
      
        // this.handleEmailChange = this.handleEmailChange.bind(this);
        // this.handlePasswordChange = this.handlePasswordChange.bind(this);
    }

    handleAddressChange = ev => {
      this.setState({ address: ev.target.value });        
    }

    handleCityChange = ( ev ) => {
      this.setState({ city: ev.target.value });        
    }

    handleStateChange = ( ev ) => {
      this.setState({ state: ev.target.value });        
    }

    handleCountryChange = ( ev ) => {
      this.setState({ country: ev.target.value });        
    }

    handlePostalCodeChange = ( ev ) => {
      this.setState({ postalCode: ev.target.value });        
    }

    handleNameChange = ev => {
        this.setState({ name: ev.target.value });        
    }

    handleEmailChange = ev => {
        this.setState({ email: ev.target.value });        
    }

    handleSubmit = ev => {

    // We don't want to let default form submission happen here, which would refresh the page.
        this.setState({response : null, needLoading: true});
        let campaign = this.props.campaign;
        // process.env.REACT_APP_STAGE === 'fake' && this.props.history.push(`/dashboard/` + campaign.adamId);

        const { appId, budget, region } = this.props.addBudgetData;
        const { bundleId, appName } = this.props.currentApp;
        const { getAccessToken } = this.props.auth;
        const headers = { 'Authorization': `Bearer ${getAccessToken()}`}

        ev.preventDefault();

        this.props.stripe.createToken(
          {
            name: this.props.profile.name, // card holder name
            // address_line1: this.state.address,
            email: this.props.profile.email
          }
        ).then((payload) => {
            // axios.post(`${API_URL}/searchads/campaigns/create/`, request, { headers } )
            // .then(response => {
            //   this.setState({ message: 'asdfsdf', response: response.data})
            //   this.props.history.push(`/profile`) 
            // })
            // .catch(error => this.setState({ message: error.message }));
          
            console.log('Received Stripe token:', payload);
            console.log('Received campaign:', campaign);
            console.log('Received appName:', appName);
            // return;
            NProgress.start();
            const postData = {
              token: payload.token,
              appId,
              region,
              budget: parseFloat(budget)
            };
            this.setState({ postData})

            axios.post(`${PAYMENT_SERVER_URL}/order/budget/`, postData, { headers } )                                  
            .then(response => {
              NProgress.done();

              console.log( response)
              // this.props.history.push(`/dashboard/` + campaign.adamId  );

              this.props.updateResult( true, response);
              // this.props.isFinishPurhcase(response)
              // this.props.history.push(`/profile`) 
              console.log ( ' 200 ')
            })
            .catch(error => {
              NProgress.done();

              const response = error.response;
              this.setState({ response: response.data })
              console.log ( ' 500 ', response)
              this.props.updateError( false, response.data);

              
            });
          }
        
        );
        
  };


  render() {
    console.log( ' API_URL : ', PAYMENT_SERVER_URL , process.env)
    return (
      <SplitFormWrapper>
        {
          this.state.needLoading && (
            <OverlayLoading/>
          )
        }
      <form onSubmit={this.handleSubmit}>
        <label className="StripeLabel">
        <CardElement
        hidePostalCode={ true}
          onBlur={handleBlur}
          onChange={handleChange}
          onFocus={handleFocus}
          onReady={handleReady}
            {...createOptions(this.props.fontSize)}
          />
        </label>
        <div className="my-input" id="card-element"></div>
        {/* <button>Pay</button> */}
        <p>
          <img className="visa" src={VISAImg} alt="visa"/>
          <img className="master" src={MasterImg} alt="master"/>
          <img className="ae" src={AEImg} alt="ae"/>
          <img className="apple-pay" src={ApplePayImg} alt="apple-pay"/>
          <img className="android-pay" src={AndroidPayImg} alt="android-pay"/>
        </p>
        {/* <div className="submit-area row m0" onClick={this.handleSubmit}>
            <a href="javascript:void(0);" 
            className="btn btn-rounded btn-block" 
            id="next-personal">Order now</a>
        </div> */}

          <p>
          <Checkbox handleChick={()=>{console.log(arguments)}}><span className="remeber-card">Save this card</span></Checkbox>
          {/* <input type="checkbox" id="remeber-card"/> */}
          {/* <label htmlFor="remeber-card">Save this card</label> */}
        </p>

        {/* <button type="submit" className="btn-create-campaign" onClick={this.handleSubmit}>
          CONFIRM PAYMENT
          <img src={DownloadGreenUpArrow}/>
        </button> */}

        
        <button type="submit" 
          className="btn-create-campaign" 
          onClick={this.handleSubmit}>
          CONFIRM PAYMENT <img src={DownloadGreenUpArrow}/>
        </button>
        
      { this.state.response && <ReactJson src={this.state.response} /> }
      { this.state.response && <ReactJson src={this.state.postData} /> }

      </form>
      </SplitFormWrapper>
    );
  }
}

export default injectStripe(CheckoutForm);


// WEBPACK FOOTER //
// ./src/containers/Dashboard/CheckoutForm.js